import { Types } from '../../../constants';
import { WrapHelper } from '../WrapHelper';
export class WrapStringHelper extends WrapHelper {
    constructor() {
        super(...arguments);
        this.type = Types.String;
    }
}

//# sourceMappingURL=WrapStringHelper.js.map
